import React                                   from 'react';
import NumberLayer                             from 'pu-react/components/NumberLayer';
import { numberLayer as numberLayerRidigFlex } from 'pu-data/SelectOptions';
import { numberLayerFlex }                     from '../../data/SelectOptions';

const Component = (props) => {
  if (!props.show) { return null; }
  const options = props.parameters.rigid_flex_selector === 'Flex'
    ? numberLayerFlex
    : numberLayerRidigFlex;
  return <NumberLayer {...props} options={options} />;
};

Component.defaultProps = {
  show: true,
};

export default Component;
